import React from "react";

export const SmallLoader = ({ height = "screen" }) => (
  // <div className="center">
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  //   <div className="wave"></div>
  // </div>
  <div class="flex items-center justify-center  h-screen ">
    <div className="p-4 max-w-sm w-full mx-auto">
      <div class="animate-pulse flex justify-center space-x-4">
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        <div class="rounded-full bg-slate-700 h-5 w-5"></div>
        {/* <div class="flex-1 space-y-6 py-1">
          <div class="h-2 bg-slate-700 rounded"></div>
          <div class="space-y-3">
            <div class="grid grid-cols-3 gap-4">
              <div class="h-2 bg-slate-700 rounded col-span-2"></div>
              <div class="h-2 bg-slate-700 rounded col-span-1"></div>
            </div>
            <div class="h-2 bg-slate-700 rounded"></div>
          </div>
        </div> */}
      </div>
    </div>
  </div>
);
